import React, { Component } from 'react'
import Slider from "react-slick";
import Styles from '../../Css/View360/View360.module.css'
import { connect } from 'react-redux'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export const layout = {
    outerGutter: 0,
    gutterSize: 0,
}
export const colors = {
    white: '#FFFFFF',
    lightestGray: '#F7F7F7', //Background
    lighterGray: '#F4F4F4', //Borders (Input / Nav)
    lightGray: '#E5E5E5',
    gray: '#C5C5C5',
    darkGray: '#A4A4A4',
    darkerGray: '#5E5E5E',
    black: '#39444C',

    blue: '#007CC3',
    green: '#4ADEC2',

    shadow: 'rgba(0,0,0,0.1)',
    gradient: degree => `linear-gradient(${degree}deg, #4ADEC2, #007CC3)`,
}
class View360Slider extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modalList: new Map(),
            modalListKeys: [],
            goToSlide: 0,
            setTitle: '',
            showModal : false,
        };
        this.sliderRef = React.createRef()
    }

    componentDidUpdate(prevProps) {
        if (this.props.goToSlide !== prevProps.goToSlide) {
            // Make sure sliderRef is not null
            // if (this.sliderRef && this.sliderRef.current) {
                // Call slickGoTo to navigate to the specified slide
                this.sliderRef.slickGoTo(this.props.goToSlide);
                console.log(this.props.goToSlide,'1')
            // }
        }
        console.log(this.props.goToSlide,'2')
    }

    async componentDidMount() {
        // sliderSettings.nextArrow = <AtomicComponent.SampleNextArrow 
        //                                 customClassName="slider-next slider-next-arrow" 
        //                                 customStyle={{ cursor:"pointer", fontSize:'50px', position: 'absolute',right: 0,top: '40%'}}
        //                                 arrowIconClass="fa fa-caret-right"
        //                             />;

        // sliderSettings.prevArrow = <AtomicComponent.SamplePrevArrow 
        //                                 customClassName="slider-prev slider-prev-arrow" 
        //                                 customStyle={{ cursor:"pointer", fontSize:'50px', position: 'absolute',left: 0,top: '40%'}} 
        //                                 arrowIconClass="fa fa-caret-left"
        //                             />
        let listOfModal = [...this.props.modalList.keys()]
        let title = listOfModal[this.props.goToSlide]
        let getTitle = this.props.modalList.get(title).title;
        await this.setState({ ...this.state, modalList: this.props.modalList, modalListKeys: [...this.props.modalList.keys()], goToSlide: this.props.goToSlide, setTitle: getTitle })

        if (this.sliderRef) {
            this.sliderRef.slickGoTo(this.props.goToSlide);
        }
    }


    /**
     * Show modal on button click
     * @param {*} e 
     * @returns 
     */
    hotSpotModelViewBtnClick = (url) => {
        try {
            if (!url) return;
            window?.open(url);
        } catch (error) {
            //console.log(error)
        }
    }


    Capitalize = (sentence) => {
        if(!sentence) return '';
        try {
            let words = sentence.split(/[\s_]+/);

    
            // Capitalize the first character of each word
            let capitalizedWords = words?.map(word => {
                // Capitalize the first character and concatenate with the rest of the word in lowercase
                return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase();
            });
            
            // Join the words back into a single string
            return capitalizedWords.join(" ");
        } catch (error) {
            
        }
    }

    render() {
        const settings = {
            accessibility: true,
            autoplay: false,
            autoplaySpeed: 5000,
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            swipe: false
        }

        const styles = {
            container: {
                paddingLeft: layout.outerGutter,
                paddingTop: layout.outerGutter,
                paddingRight: layout.outerGutter,
            },
            contentConatiner: {
                maxWidth: 1200,
                marginLeft: 'auto',
                marginRight: 'auto',
                backgroundColor: colors.white,
                paddingTop: layout.outerGutter,
                paddingLeft: layout.outerGutter,
                paddingRight: layout.outerGutter,
            },

            headerContainer: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: layout.outerGutter,
                flexWrap: 'wrap',
                flexDirection: 'column',
            },
            title: {
                fontSize: 50,
                marginTop: 0,
                marginBottom: layout.outerGutter / 2,
                textAlign: 'center',
                lineHeight: 1.25,
            },
            categories: {
                fontSize: 20,
                fontWeight: 300,
                marginTop: 0,
                marginBottom: 0,
                textAlign: 'center',

            },
            category: {
                paddingLeft: layout.outerGutter / 2,
            },
            headerSliderContainer: {
                width: '100%',
                paddingLeft: layout.outerGutter,
                paddingRight: layout.outerGutter,
                height : '170px',
                position : 'relative'
            },
            headerImageContainer: {
                width: '100%',
            },
            headerImage: {
                width: '100%',
                height: '170px',
                objectFit: 'cover',
                objectPosition: 'center',
                borderRadius : '6px'
            },
        }
        return (
            <>
                <div className={[Styles['container-popup']]} style={{
                    maxWidth: `${((window?.innerWidth || 1440) / 5)}px`, width: `${((window?.innerWidth || 1440)/ 5)}px`, height: `${Math.round((((window?.innerWidth || 1440) / 5) / 16) * 9)}px!important`, paddingLeft: layout.outerGutter,
                    paddingTop: layout.outerGutter,
                    paddingRight: layout.outerGutter
                }}>
                    <div className={[Styles['header-icon-container']]}>
                        <div className={[Styles['cross-icon']]} onClick={() => this.props.hideModal()}>
                            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                <g id="Frame 1000003102">
                                    <path id="Vector" d="M7 8.26286L3.64639 11.6165C3.52091 11.742 3.36122 11.8047 3.1673 11.8047C2.97338 11.8047 2.81369 11.742 2.68821 11.6165C2.56274 11.491 2.5 11.3313 2.5 11.1374C2.5 10.9435 2.56274 10.7838 2.68821 10.6583L6.04183 7.30469L2.68821 3.95108C2.56274 3.8256 2.5 3.6659 2.5 3.47199C2.5 3.27807 2.56274 3.11838 2.68821 2.9929C2.81369 2.86743 2.97338 2.80469 3.1673 2.80469C3.36122 2.80469 3.52091 2.86743 3.64639 2.9929L7 6.34651L10.3536 2.9929C10.4791 2.86743 10.6388 2.80469 10.8327 2.80469C11.0266 2.80469 11.1863 2.86743 11.3118 2.9929C11.4373 3.11838 11.5 3.27807 11.5 3.47199C11.5 3.6659 11.4373 3.8256 11.3118 3.95108L7.95818 7.30469L11.3118 10.6583C11.4373 10.7838 11.5 10.9435 11.5 11.1374C11.5 11.3313 11.4373 11.491 11.3118 11.6165C11.1863 11.742 11.0266 11.8047 10.8327 11.8047C10.6388 11.8047 10.4791 11.742 10.3536 11.6165L7 8.26286Z" fill="white" />
                                </g>
                            </svg>
                        </div>
                        <div className={[Styles['left-right-count-container']]}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" onClick={() => this.props.decrement()}>
                                <rect y="0.304688" width="24" height="24" rx="12" fill="black" fill-opacity="0.6" />
                                <rect x="0.5" y="0.804688" width="23" height="23" rx="11.5" stroke="white" stroke-opacity="0.2" />
                                <path d="M13.3008 17.6016L8.70078 13.0016C8.60078 12.9016 8.52995 12.7932 8.48828 12.6766C8.44661 12.5599 8.42578 12.4349 8.42578 12.3016C8.42578 12.1682 8.44661 12.0432 8.48828 11.9266C8.52995 11.8099 8.60078 11.7016 8.70078 11.6016L13.3008 7.00156C13.4841 6.81823 13.7174 6.72656 14.0008 6.72656C14.2841 6.72656 14.5174 6.81823 14.7008 7.00156C14.8841 7.1849 14.9758 7.41823 14.9758 7.70156C14.9758 7.9849 14.8841 8.21823 14.7008 8.40156L10.8008 12.3016L14.7008 16.2016C14.8841 16.3849 14.9758 16.6182 14.9758 16.9016C14.9758 17.1849 14.8841 17.4182 14.7008 17.6016C14.5174 17.7849 14.2841 17.8766 14.0008 17.8766C13.7174 17.8766 13.4841 17.7849 13.3008 17.6016Z" fill="white" />
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" onClick={() => this.props.increment()}>
                                <rect y="0.304688" width="24" height="24" rx="12" fill="black" fill-opacity="0.6" />
                                <rect x="0.5" y="0.804688" width="23" height="23" rx="11.5" stroke="white" stroke-opacity="0.2" />
                                <path d="M8.70078 17.6016C8.51745 17.4182 8.42578 17.1849 8.42578 16.9016C8.42578 16.6182 8.51745 16.3849 8.70078 16.2016L12.6008 12.3016L8.70078 8.40156C8.51745 8.21823 8.42578 7.9849 8.42578 7.70156C8.42578 7.41823 8.51745 7.1849 8.70078 7.00156C8.88411 6.81823 9.11745 6.72656 9.40078 6.72656C9.68411 6.72656 9.91745 6.81823 10.1008 7.00156L14.7008 11.6016C14.8008 11.7016 14.8716 11.8099 14.9133 11.9266C14.9549 12.0432 14.9758 12.1682 14.9758 12.3016C14.9758 12.4349 14.9549 12.5599 14.9133 12.6766C14.8716 12.7932 14.8008 12.9016 14.7008 13.0016L10.1008 17.6016C9.91745 17.7849 9.68411 17.8766 9.40078 17.8766C9.11745 17.8766 8.88411 17.7849 8.70078 17.6016Z" fill="white" />
                            </svg>
                        </div>
                    </div>
                                        <div className={[Styles['header-slider-container']]} >
                        <Slider {...settings}
                            className={[Styles['slick-slider-custom']]}
                            ref={slider => (this.sliderRef = slider)}
                        >
                            {
                                this.state.modalListKeys.length ? this.state.modalListKeys.map(hotSpotKey => {
                                    return (
                                        <div className={[Styles['card-container-custom']]} key={`${hotSpotKey}_view360`} >
                                            <div className={[Styles['slick-contents-container']]} >
                                                                                                {
                                                    this?.props?.modalList.get(hotSpotKey)?.closeUpURL ? (
                                                        <img variant="top" src={this?.props?.modalList.get(hotSpotKey)?.closeUpURL} alt="" style={{ height: `${Math.round((((window?.innerWidth || 1440) / 5) / 16) * 9)}px` }} className={[Styles['image-modal-container']]} />
                                                    ) : null
                                                }

                                            </div>
                                        </div>
                                    )
                                }) : null
                            }
                        </Slider>
                        <div className={[Styles['info-container']]}>
                            <p>{this.Capitalize(this.state.modalList.get(this.state.modalListKeys[this.props.goToSlide])?.desc) || ''} <span>{this.props.goToSlide + 1} / {this.state.modalListKeys.length}</span></p>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" 
                                onClick={()=>{
                                    this.setState({...this.state,showModal : true})
                                    this.props.viewedFullScreenModal();
                                }}>
                                <rect y="0.304688" width="24" height="24" rx="12" fill="black" fill-opacity="0.4" />
                                <path d="M8.56295 15.0489L10.285 13.3268C10.3823 13.2295 10.4967 13.1808 10.628 13.1808C10.7593 13.1808 10.8737 13.2295 10.971 13.3268C11.0683 13.4241 11.117 13.5385 11.117 13.6698C11.117 13.8011 11.0683 13.9154 10.971 14.0128L9.25596 15.7278L10.6597 15.7208C10.7957 15.7208 10.9124 15.768 11.0097 15.8624C11.107 15.9568 11.1557 16.0749 11.1557 16.2168C11.1557 16.3587 11.1085 16.4768 11.0141 16.5712C10.9197 16.6656 10.8016 16.7128 10.6597 16.7128L8.16368 16.7128C8.07807 16.7128 8.00273 16.6978 7.93765 16.6679C7.87257 16.638 7.81248 16.5955 7.75736 16.5404C7.70224 16.4853 7.65974 16.4252 7.62984 16.3601C7.59993 16.2951 7.58498 16.2197 7.58499 16.1341L7.58499 13.624C7.58498 13.488 7.63218 13.3737 7.72657 13.2811C7.82096 13.1884 7.93911 13.1421 8.081 13.1421C8.22288 13.1421 8.33985 13.1881 8.4319 13.2802C8.52396 13.3722 8.56998 13.4892 8.56998 13.6311L8.56295 15.0489ZM8.56998 9.55374L8.57702 10.9574C8.57702 11.0935 8.52983 11.2101 8.43543 11.3075C8.34102 11.4048 8.22288 11.4535 8.081 11.4535C7.93911 11.4535 7.82096 11.4063 7.72657 11.3119C7.63218 11.2175 7.58498 11.0993 7.58498 10.9574L7.58499 8.46146C7.58498 8.37585 7.59993 8.30051 7.62984 8.23543C7.65974 8.17035 7.70224 8.11026 7.75736 8.05514C7.81248 8.00002 7.87257 7.95752 7.93765 7.92762C8.00273 7.89771 8.07807 7.88276 8.16368 7.88277L10.6597 7.88276C10.7957 7.88276 10.9112 7.92879 11.0062 8.02084C11.1012 8.11289 11.1486 8.22985 11.1486 8.37174C11.1486 8.51363 11.1026 8.6306 11.0106 8.72265C10.9185 8.81471 10.8015 8.86073 10.6597 8.86072L9.24893 8.86073L10.971 10.5828C11.0683 10.6801 11.117 10.7944 11.117 10.9258C11.117 11.0571 11.0683 11.1714 10.971 11.2688C10.8737 11.3661 10.7593 11.4148 10.628 11.4148C10.4967 11.4148 10.3823 11.3661 10.285 11.2688L8.56998 9.55374ZM14.7511 15.7348L13.029 14.0128C12.9317 13.9154 12.883 13.8011 12.883 13.6698C12.883 13.5385 12.9317 13.4241 13.029 13.3268C13.1263 13.2295 13.2407 13.1808 13.372 13.1808C13.5033 13.1808 13.6177 13.2295 13.715 13.3268L15.43 15.0418L15.423 13.6381C15.423 13.5021 15.4702 13.3854 15.5646 13.2881C15.659 13.1908 15.7771 13.1421 15.919 13.1421C16.0609 13.1421 16.179 13.1893 16.2734 13.2837C16.3678 13.3781 16.415 13.4962 16.415 13.6381L16.415 16.1341C16.415 16.2197 16.4001 16.2951 16.3702 16.3601C16.3403 16.4252 16.2978 16.4853 16.2426 16.5404C16.1875 16.5955 16.1274 16.638 16.0623 16.6679C15.9973 16.6978 15.9219 16.7128 15.8363 16.7128L13.3263 16.7128C13.1902 16.7128 13.0771 16.6668 12.9868 16.5747C12.8965 16.4827 12.8514 16.3657 12.8514 16.2238C12.8514 16.0819 12.8974 15.965 12.9894 15.8729C13.0815 15.7809 13.1985 15.7348 13.3403 15.7348L14.7511 15.7348ZM14.7511 8.86073H13.3263C13.1902 8.86073 13.0759 8.81588 12.9833 8.72618C12.8906 8.63646 12.8443 8.52066 12.8443 8.37878C12.8443 8.23689 12.8903 8.11992 12.9824 8.02787C13.0744 7.93582 13.1914 7.8898 13.3333 7.8898L15.8363 7.88277C15.9219 7.88276 15.9973 7.89771 16.0623 7.92762C16.1274 7.95752 16.1875 8.00002 16.2426 8.05514C16.2978 8.11026 16.3403 8.17035 16.3702 8.23543C16.4001 8.30051 16.415 8.37585 16.415 8.46146L16.415 10.9715C16.415 11.1075 16.3702 11.2219 16.2805 11.3145C16.1908 11.4071 16.075 11.4535 15.9331 11.4535C15.7912 11.4535 15.6742 11.4074 15.5822 11.3154C15.4901 11.2233 15.4441 11.1064 15.4441 10.9645L15.437 9.54671L13.715 11.2688C13.6177 11.3661 13.5033 11.4148 13.372 11.4148C13.2407 11.4148 13.1263 11.3661 13.029 11.2688C12.9317 11.1714 12.883 11.0571 12.883 10.9258C12.883 10.7944 12.9317 10.6801 13.029 10.5828L14.7511 8.86073Z" fill="white" />
                            </svg>

                        </div>
                    </div>
                </div>
              {this?.state?.showModal ?   <div className={[Styles["yourModal"]]} tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-modal="true">
                    <div className={[Styles["yourModalBackdrop"]]}></div>
                    <div className={[Styles["yourModalContent"]]}>
                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={[Styles[this.props.goToSlide + 1 == 1 ? 'modal-image-viewer-hidden' :'modal-image-viewer']]} onClick={() => this.props.decrement()}>
                            <rect x="64" y="64" width="64" height="64" rx="32" transform="rotate(180 64 64)" fill="black" fill-opacity="0.4" />
                            <path d="M26.4623 31.9935L39.4971 45.0284C39.841 45.3722 40.0085 45.7815 39.9997 46.2563C39.9908 46.7311 39.8144 47.1404 39.4705 47.4842C39.1267 47.8281 38.7174 48 38.2426 48C37.7679 48 37.3586 47.8281 37.0147 47.4842L23.7669 34.2098C23.4541 33.897 23.2223 33.5465 23.0714 33.1582C22.9206 32.77 22.8451 32.3817 22.8451 31.9935C22.8451 31.6053 22.9206 31.2171 23.0714 30.8288C23.2223 30.4406 23.4541 30.0901 23.7669 29.7773L37.0413 16.5029C37.3852 16.159 37.7901 15.9915 38.256 16.0003C38.7218 16.0092 39.1267 16.1856 39.4705 16.5295C39.8144 16.8733 39.9863 17.2826 39.9863 17.7574C39.9863 18.2321 39.8144 18.6414 39.4705 18.9853L26.4623 31.9935Z" fill="white" />
                        </svg>
                        <div className={[Styles['image-modal']]} style={{ width: `${((window?.innerWidth || 1440) / 1.5)}px`, height: `${Math.round((((window?.innerWidth || 1440) / 1.5) / 16) * 9)}px` }}>
                            <div className={[Styles['info-container']]}>
                                <p>{this.Capitalize(this.state.modalList.get(this.state?.modalListKeys[this.props.goToSlide])?.desc) || ''} <span>{this.props.goToSlide + 1} / {this.state.modalListKeys?.length || ''}</span></p>
                                <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={()=>this.setState((prev)=>({...prev,showModal : !this.state.showModal}))}>
                                    <rect y="0.9375" width="40" height="40" rx="20" fill="black" fill-opacity="0.6" />
                                    <path d="M20.0019 22.5345L14.4126 28.1238C14.2035 28.3329 13.9373 28.4375 13.6141 28.4375C13.2909 28.4375 13.0248 28.3329 12.8156 28.1238C12.6065 27.9147 12.502 27.6485 12.502 27.3253C12.502 27.0021 12.6065 26.736 12.8156 26.5269L18.405 20.9375L12.8156 15.3481C12.6065 15.139 12.502 14.8729 12.502 14.5497C12.502 14.2265 12.6065 13.9603 12.8156 13.7512C13.0248 13.5421 13.2909 13.4375 13.6141 13.4375C13.9373 13.4375 14.2035 13.5421 14.4126 13.7512L20.0019 19.3405L25.5913 13.7512C25.8004 13.5421 26.0666 13.4375 26.3898 13.4375C26.713 13.4375 26.9791 13.5421 27.1883 13.7512C27.3974 13.9603 27.5019 14.2265 27.5019 14.5497C27.5019 14.8729 27.3974 15.139 27.1883 15.3481L21.5989 20.9375L27.1883 26.5269C27.3974 26.736 27.5019 27.0021 27.5019 27.3253C27.5019 27.6485 27.3974 27.9147 27.1883 28.1238C26.9791 28.3329 26.713 28.4375 26.3898 28.4375C26.0666 28.4375 25.8004 28.3329 25.5913 28.1238L20.0019 22.5345Z" fill="white" />
                                </svg>
                            </div>
                            <img src={this.state.modalList.get(this.state?.modalListKeys[this.props.goToSlide])?.closeUpURL} alt="Modal Image" style={{ width: `${((window?.innerWidth || 1440) / 1.5)}px`, height: `${Math.round((((window?.innerWidth || 1440) / 1.5) / 16) * 9)}px` }} loading="eager" fetchPriority="high"/>
                        </div>
                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => this.props.increment()} className={[Styles[this.props.goToSlide + 1 == this.state.modalListKeys?.length ? 'modal-image-viewer-hidden' : 'modal-image-viewer']]} >
                            <g id="arrow_forward_ios_FILL0_wght300_GRAD0_opsz24 1">
                                <rect width="64" height="64" rx="32" fill="black" fill-opacity="0.4" />
                                <path id="Vector" d="M37.5377 32.0065L24.5029 18.9716C24.159 18.6278 23.9915 18.2185 24.0003 17.7437C24.0092 17.2689 24.1856 16.8596 24.5295 16.5158C24.8733 16.1719 25.2826 16 25.7574 16C26.2321 16 26.6414 16.1719 26.9853 16.5158L40.2331 29.7902C40.5459 30.103 40.7777 30.4535 40.9286 30.8418C41.0794 31.23 41.1549 31.6183 41.1549 32.0065C41.1549 32.3947 41.0794 32.7829 40.9286 33.1712C40.7777 33.5594 40.5459 33.9099 40.2331 34.2227L26.9587 47.4971C26.6148 47.841 26.2099 48.0085 25.744 47.9997C25.2782 47.9908 24.8733 47.8144 24.5295 47.4705C24.1856 47.1267 24.0137 46.7174 24.0137 46.2426C24.0137 45.7679 24.1856 45.3586 24.5295 45.0147L37.5377 32.0065Z" fill="white" />
                            </g>
                        </svg>
                    </div>
                </div> : null}
            </>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        hotSpotMapObj: state.view360Reducer.hotSpotMapObj,
    }
}

export default connect(mapStateToProps, null)(View360Slider);
